import { render, staticRenderFns } from "./tj_confirmCase.vue?vue&type=template&id=a247001a&scoped=true&"
import script from "./tj_confirmCase.vue?vue&type=script&lang=js&"
export * from "./tj_confirmCase.vue?vue&type=script&lang=js&"
import style0 from "./tj_confirmCase.vue?vue&type=style&index=0&id=a247001a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a247001a",
  null
  
)

export default component.exports